import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';

const NAV_ROUTES = [
  { key: 'home', to: '/' },
  { key: 'insights', to: '/demo' },
  { key: 'methodology', to: '/methodology' },
  { key: 'coverage', to: '/coverage' },
  { key: 'survey', to: '/survey' },
];

const isActiveRoute = (pathname: string, target: string): boolean => {
  if (target === '/') return pathname === '/';
  return pathname === target || pathname.startsWith(`${target}/`);
};

export const PublicSiteHeader: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation('navigation');

  return (
    <header className="sticky top-0 z-20 border-b border-[#E2E8F0] bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
        <Link to="/" className="flex-shrink-0" aria-label="BrandEdge home">
          <img
            src="/BrandEdge_Web_Pack/brandedge-logo-white-bg-original.png"
            alt="BrandEdge"
            className="h-9 w-auto sm:h-10"
            style={{ objectFit: 'contain' }}
            draggable={false}
          />
        </Link>
        <nav className="hidden items-center gap-5 text-xs font-semibold uppercase tracking-widest text-[#475569] md:flex">
          {NAV_ROUTES.map((item) => (
            <Link
              key={item.key}
              to={item.to}
              className={`transition-colors ${isActiveRoute(location.pathname, item.to) ? 'text-[#0F172A]' : 'hover:text-[#0F172A]'}`}
            >
              {t(item.key)}
            </Link>
          ))}
          <Link
            to="/get-started"
            className="rounded-lg bg-[#E10613] px-4 py-2 text-white transition-colors hover:bg-[#C1121F]"
          >
            {t('getStarted')}
          </Link>
          <Link
            to="/login"
            className={`rounded-lg border border-[#E2E8F0] px-4 py-2 transition-colors hover:border-[#CBD5E1] hover:text-[#0F172A] ${isActiveRoute(location.pathname, '/login') ? 'text-[#0F172A]' : ''}`}
          >
            {t('login')}
          </Link>
          <LanguageSwitcher variant="dark" />
        </nav>
      </div>
    </header>
  );
};
